import React from 'react';

interface TipoBadgeProps {
  tipo: string;
}

const colorMap: Record<string, string> = {
  produttivo: 'bg-blue-100 text-blue-800',
  ausiliario: 'bg-amber-100 text-amber-800',
  funzionale: 'bg-green-100 text-green-800',
  comune: 'bg-gray-100 text-gray-700',
};

const TipoBadge: React.FC<TipoBadgeProps> = ({ tipo }) => {
  const cls = colorMap[tipo] ?? 'bg-gray-100 text-gray-700';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${cls}`}>
      {tipo}
    </span>
  );
};

export default TipoBadge;
